:host {
  display: block;
  margin: 0 0 -1px 0;
  border-top: 1px solid var(--color-light-gray);
  border-bottom: 1px solid var(--color-light-gray);
  padding: 0 20px;
}

.heading {
  color: var(--color-cwru-blue);
  font-size: 20px;
  font-weight: var(--font-weight-bold);
  margin: 0;
}

h2 button {
  all: inherit;
  width: 100%;
  cursor: pointer;
  padding: 20px 15px 20px 25px;
}

[aria-expanded='false'] {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAARCAYAAADtyJ2fAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTExIDc5LjE1ODMyNSwgMjAxNS8wOS8xMC0wMToxMDoyMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MzEwRTk3N0IzMjcwMTFFNjhDNEFBRjMwMzFGMjVEMjciIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MzEwRTk3N0EzMjcwMTFFNjhDNEFBRjMwMzFGMjVEMjciIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MDM3MkM0MTZGM0M1MTFFNUI2MUNBRURGMkMyRTQ4QkYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MDM3MkM0MTdGM0M1MTFFNUI2MUNBRURGMkMyRTQ4QkYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5Etn1qAAAAY0lEQVR42mL8//8/AzmAkVyNTOgC3Ib+/0m2EVnT1/MbGUmykVibMfyIrgGXzVgDhxjNOEOVkGa80YFPMxMDmYC6TiUrcMiKDmI14Q0cQkmOAWQjMuYy8PuPLoYNk52tAAIMAL8qddv26/mOAAAAAElFTkSuQmCC)
    left no-repeat;
}
[aria-expanded='true'] {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAARCAYAAADtyJ2fAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTExIDc5LjE1ODMyNSwgMjAxNS8wOS8xMC0wMToxMDoyMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6M0I3REQ4MzYzMjcwMTFFNjlFQ0U4QkRDRERBOTlCQzciIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6M0I3REQ4MzUzMjcwMTFFNjlFQ0U4QkRDRERBOTlCQzciIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MDM3MkM0MTZGM0M1MTFFNUI2MUNBRURGMkMyRTQ4QkYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MDM3MkM0MTdGM0M1MTFFNUI2MUNBRURGMkMyRTQ4QkYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5QpSClAAAAYElEQVR42mL8//8/AzmAiYFMMNQ0chv6/wdhQoqR1TFyGfihaPh6fiMjLk0oNqIrxGYzuhhIDxM2W5AVYtMEdipyAiDkT2QLmIjxHzY5JkIKcIkxETIdlysYR0AiBwgwABbuN4lWwK0JAAAAAElFTkSuQmCC)
    left no-repeat;
}

.content {
  padding: 0 15px 0 25px;
}
.content.open {
  display: block;
  transition: height 0.5s ease;
  overflow: hidden;
}
.content.closed {
  display: none;
}

::slotted(p) {
  margin-top: 0 !important;
}
